<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
    }
  },
  created() {
    // 获取二级域名，跳入到单个赛事主页
    let host = window.location.host
    let splitStr = host.split('.')
    if (splitStr.length === 3) {
      if (splitStr[1] === 'daoba' && splitStr[0] !== 'www' && splitStr[0] !== 'db') {
        this.$api.match
          .queryMatchIdByDomain({ domain: splitStr[0] })
          .then((res) => {
            if (res.status === 0) {
              window.location.href =
                'https://www.daoba.com/MatchDetail?matchId=' + res.data.matchId + '&programId=' + res.data.programId
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  },
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
#app {
  height: 100%;
  display: flex;
}
// :global(.ant-btn-primary){
//     color: #fff;
//     background: #b99523 !important;
//     border-color: #b99523 !important;
// }
// .ant-btn-primary:hover, .ant-btn-primary:focus{
//     color: #fff;
//     background: #b99523 !important;
//     border-color: #b99523 !important;
// }
// .ant-btn-primary:active{
//     color: #fff;
//     background: #4dff97 !important;
//     border-color: #4dff97 !important;
// }
// :global(.ant-input-primary){
//     color: #fff;
//     background: #b99523 !important;
//     border-color: #b99523 !important;
// }
// .ant-input-primary:hover, .ant-input-primary:focus{
//     color: #fff;
//     background: #b99523 !important;
//     border-color: #b99523 !important;
// }
// .ant-input-primary:active{
//     color: #fff;
//     background: #4dff97 !important;
//     border-color: #4dff97 !important;
// }
.m-color {
  color: #be1e28;
}
.b-color {
  background-color: #be1e28;
}
.c-red {
  color: #f73c13;
}
.b-red {
  background-color: #f73c13;
}
.c-blue {
  color: #1890ff;
}
.b-blue {
  background-color: #1890ff;
}
.c-green {
  color: #009900;
}
.b-green {
  background-color: #009900;
}
.c-yellow {
  color: #ffc000;
}
.b-yellow {
  background-color: #ffc000;
}
.c-gray {
  color: #bbbbbb;
}
.b-gray {
  background-color: #bbbbbb;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/App.vue